angular.module('autoremind.templates')
    .directive('setTemplateToUser', ['templateAr2Service', '$timeout', 'dialogs',
    function (templateAr2Service, $timeout, dialogs) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/templates/set-template-to-user.html',
            link: function (scope, elem, attr) {
                scope.viewModel = {
                    loadingIndicator: {
                        refCount: 0,
                        state: false
                    },
                    templateName: '',
                    alreadyInUse: false,
                    templateNameExist: false,
                    templateChecked: false
                };
                scope.init = function () {
                    templateAr2Service.parseTemplate(scope.template.file, scope.viewModel.loadingIndicator)
                        .then(function (res) {
                        scope.viewModel.templateName = angular.isDefined(res.templateVariables.templateName) ? res.templateVariables.templateName : '';
                        scope.checkTemplateName();
                    }, function () {
                        scope.viewModel.templateName = '';
                    });
                }();
                scope.confirmReplacing = function () {
                    dialogs.confirm('Confirm replacing the template', 'A template with the same template name (' + scope.template.type + ' + ' + scope.viewModel.templateName + ' + ' + scope.template.language + ') is already assigned to this user. Are you sure you wish to assign the selected template in stead?')
                        .result.then(function () {
                        scope.mapTemplateToUser(true);
                    }, function () {
                    });
                };
                scope.mapTemplateToUser = function (skipPrompt) {
                    if (scope.viewModel.templateNameExist && !skipPrompt) {
                        scope.confirmReplacing();
                        return;
                    }
                    templateAr2Service.setTemplateToUser(scope.isClone, scope.template, scope.viewModel.templateName, scope.viewModel.loadingIndicator)
                        .then(function (res) {
                        if (angular.isDefined(res.rejectedExist) && res.rejectedExist) {
                            scope.viewModel.alreadyInUse = 'Current template name already exists. If you do not wish to replace the current assignment please enter another name';
                            return;
                        }
                        scope.success();
                    });
                };
                var _timeout;
                scope.checkTemplateName = function () {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        if (scope.viewModel.templateName === '') {
                            scope.viewModel.alreadyInUse = 'The template name must contain at least one character.';
                            return;
                        }
                        var requestData = {
                            fileName: scope.template.fileName,
                            templateName: scope.viewModel.templateName,
                            type: scope.template.type,
                            language: scope.template.languageId
                        };
                        templateAr2Service.checkpathandtemplatename(requestData, scope.viewModel.loadingIndicator)
                            .then(function (response) {
                            console.log('checkpathandtemplatename', response);
                            scope.viewModel.templateNameExist = response.templateNameExist;
                            scope.viewModel.templateChecked = true;
                            if (response.templateNameExist) {
                                scope.viewModel.alreadyInUse = 'Current template name already exists. If you do not wish to replace the current assignment please enter another name.';
                            }
                            else {
                                scope.viewModel.alreadyInUse = '';
                            }
                        }, function (err) {
                        });
                    }, 1000);
                };
            }
        };
    }]);
//# sourceMappingURL=set-template-to-user.directive.js.map